module.exports = __webpack_public_path__ + "dee4ba916d239558a53861de51a30bed.png";